<template>
  <div class="h-full w-full">
    <Pie :data="chartData" :options="computedOptions" />
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'
import { Pie } from 'vue-chartjs'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, ArcElement)

const props = defineProps({
  chartData: {
    type: Object,
    required: true,
  },
  chartOptions: {
    type: Object,
    default: () => ({}),
  },
})

const isDarkMode = ref(document.documentElement.classList.contains('dark'))

const computedOptions = computed(() => {
  const darkMode = isDarkMode.value
  
  return {
    ...props.chartOptions,
    plugins: {
      ...props.chartOptions.plugins,
      legend: {
        ...props.chartOptions.plugins?.legend,
        labels: {
          ...props.chartOptions.plugins?.legend?.labels,
          color: darkMode ? '#E5E7EB' : '#374151',
        },
      },
      tooltip: {
        ...props.chartOptions.plugins?.tooltip,
        backgroundColor: darkMode ? '#1F2937' : '#FFFFFF',
        titleColor: darkMode ? '#F9FAFB' : '#111827',
        bodyColor: darkMode ? '#E5E7EB' : '#374151',
        borderColor: darkMode ? '#374151' : '#E5E7EB',
        borderWidth: 1,
      },
    },
  }
})

// Watch for dark mode changes
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.attributeName === 'class') {
      isDarkMode.value = document.documentElement.classList.contains('dark')
    }
  })
})

observer.observe(document.documentElement, {
  attributes: true,
  attributeFilter: ['class'],
})
</script>
